import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './Dias.css';
import Modal from 'react-modal';
import baseURL from '../url';
import zonaHoraria from '../zonaHoraria';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import SwiperCore from 'swiper/core';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import InputMask from "react-input-mask";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Dias({ idServicio, servicio, tipoRecurso = 'programa', cupoMax }) {

    const [dias, setDias] = useState([]);
    const [dia, setDia] = useState(null);
    const [numeroSalas, setNumeroSalas] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedHorario, setSelectedHorario] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedDayIndex, setSelectedDayIndex] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [turnos, setTurnos] = useState([]);
    const [inscritosPorDia, setInscritosPorDia] = useState({});
    const [isFocused, setIsFocused] = useState(false);
    const [pago, setPago] = useState('');
    const timezone = zonaHoraria;
    const ahora = dayjs().tz(timezone);
    const fechaActual = ahora.format('YYYY-MM-DD');
    const horaActualNum = ahora.hour() + ahora.minute() / 60; // Hora actual en formato numérico
    const minDate = dayjs().add(2, 'day').format('YYYY-MM-DD');

    useEffect(() => {
        cargarDias();
        if (tipoRecurso === 'taller') {
            cargarTurnosTaller();
        } else {
            cargarTurnosySalas();
        }
    }, []);

    const cargarDias = () => {
        fetch(`${baseURL}/diasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                if (!data.dias_horarios) {
                    setDias([]);
                    setLoading(false);
                    return;
                }

                // Filtrar según el tipo de recurso
                const horariosFiltrados = data.dias_horarios.filter(item => {
                    if (tipoRecurso === 'taller') {
                        return item.tipo_recurso === 'taller' && item.idTaller == idServicio;
                    } else {
                        return item.tipo_recurso === 'programa' && item.idServicio == idServicio;
                    }
                });
                //console.log('Horarios filtrados:', horariosFiltrados);
                setDias(horariosFiltrados);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar días:', error);
                setLoading(false);
            });
    };

    const cargarTurnosySalas = () => {
        fetch(`${baseURL}/turnosPorCesecoGet.php?idServicio=${idServicio}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                // Parsear los días
                const turnosConDias = data.turnos
                    ?.map(turno => ({
                        ...turno,
                        dias: JSON.parse(turno.dias), // Convertir la cadena JSON en un objeto
                    })) || [];
                //console.log('Turnos procesados:', turnosConDias);
                setTurnos(turnosConDias);

                //obtenemos las salas del ceseco    
                fetch(`${baseURL}/salasPorCesecoGet.php?idCategoria=${data.idCategoria}`, {
                    method: 'GET',
                }).then(response => response.json())
                    .then(data => {
                        //console.log('Salas cargadas:', data.salas);
                        setNumeroSalas(data.salas.length);

                    }).catch(error => console.error('Error al cargar número de salas:', error));


            })
            .catch(error => console.error('Error al cargar turnos:', error));
    };

    const cargarTurnosTaller = async () => {
        try {
            const response = await fetch(`${baseURL}/turnosTallerGet.php?idTaller=${idServicio}`);
            const data = await response.json();

            if (data.success) {
                //console.log('Datos recibidos del servidor:', data.turnos);
                
                const turnosConDias = data.turnos?.map(turno => {
                    // Convertir el string JSON a objeto/array si es necesario
                    let dias = turno.dias;
                    if (typeof dias === 'string') {
                        try {
                            dias = JSON.parse(dias);
                        } catch (e) {
                            console.error('Error al parsear días:', e, 'Valor:', turno.dias);
                            dias = [];
                        }
                    }
                    
                    return {
                        ...turno,
                        dias: Array.isArray(dias) ? dias : []
                    };
                }) || [];

                //console.log('Turnos procesados:', turnosConDias);

                // Contar inscritos por día y horario
                const conteoInscritos = {};
                turnosConDias.forEach(turno => {
                    if (turno.dias && Array.isArray(turno.dias)) {
                        turno.dias.forEach(dia => {
                            if (dia && dia.dia && dia.horaInicio && dia.horaFin) {
                                const key = `${dia.dia}_${dia.horaInicio}_${dia.horaFin}`;
                                conteoInscritos[key] = (conteoInscritos[key] || 0) + 1;
                            }
                        });
                    }
                });
                
                setInscritosPorDia(conteoInscritos);
                setTurnos(turnosConDias);

                try {
                    const responseSalas = await fetch(`${baseURL}/salasPorCesecoGet.php?idCategoria=${data.idCategoria}`);
                    const dataSalas = await responseSalas.json();
                    setNumeroSalas(dataSalas.salas?.length || 1);
                } catch (error) {
                    console.error('Error al cargar salas:', error);
                    setNumeroSalas(1);
                }
            }
        } catch (error) {
            console.error('Error al cargar turnos de taller:', error);
            setNumeroSalas(1); // Valor por defecto
        }
    };

    useEffect(() => {
        if (dias?.length > 0) {
            // Modificar para buscar por el campo correcto según el tipo de recurso
            const diasFilt = tipoRecurso === 'taller'
                ? dias?.find(d => d.idTaller == idServicio)
                : dias?.find(d => d.idServicio == idServicio);

            if (diasFilt) {
                try {
                    // Verificar si ya es un objeto o necesita parseo
                    const parsedDias = typeof diasFilt.dias === 'string'
                        ? JSON.parse(diasFilt.dias)
                        : diasFilt.dias;

                    setDia({ ...diasFilt, dias: parsedDias });

                    // Resto del código para seleccionar el primer día disponible...
                    const monthDays = generateMonthDays();
                    let found = false;

                    for (let i = 0; i < monthDays.length; i++) {
                        const day = monthDays[i];
                        if (day.date >= minDate) {
                            const matchingDayInfo = parsedDias?.find(d => d.dia === day.day);
                            if (matchingDayInfo && matchingDayInfo.horarios?.length > 0) {
                                let isDayFull = false;
                                
                                if (tipoRecurso === 'taller') {
                                    // Para talleres, contar todas las citas en este día
                                    const citasEnEsteDia = turnos?.filter(turno => 
                                        turno?.dias?.some(d => d.dia === day.date)
                                    ).length || 0;
                                    
                                    // El día está lleno si las citas son mayores o iguales al cupo máximo
                                    isDayFull = citasEnEsteDia >= cupoMax;
                                } else {
                                    // Para programas, mantener la lógica original
                                    isDayFull = matchingDayInfo.horarios.every(horario =>
                                        turnos?.some(turno =>
                                            turno?.dias?.some(d =>
                                                d.dia === day.date &&
                                                d.horaInicio === horario.horaInicio &&
                                                d.horaFin === horario.horaFin
                                            )
                                        )
                                    );
                                }
                                if (!isDayFull) {
                                    setSelectedDay({ ...matchingDayInfo, date: day.date });
                                    setSelectedDayIndex(i);
                                    found = true;
                                    break;
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error('Error al procesar los días:', error);
                }
            } else {
                setDia(null);
            }
        }
    }, [idServicio, dias, tipoRecurso]);


    const generateMonthDays = () => {
        const daysInMonth = [];
        const today = dayjs();

        // Vamos a generar los días a partir de hoy hasta 30 días después
        const endDate = today.add(30, 'day'); // 30 días después de hoy

        for (let date = today; date.isBefore(endDate); date = date.add(1, 'day')) {
            daysInMonth.push({
                day: date.format('ddd').replace('.', '').toLowerCase(),
                date: date.format('YYYY-MM-DD'),
            });
        }

        return daysInMonth;
    };


    const handleDayClick = (monthDay, index) => {
        const selectedDayInfo = dia?.dias?.find(d => d.dia === monthDay.day);
        setSelectedDay(selectedDayInfo ? { ...selectedDayInfo, date: monthDay.date } : null);
        setSelectedHorario(null);
        setSelectedDayIndex(index);
    };

    const handleHorarioClick = (horario, date) => {
        setSelectedHorario({ horario, date });
    };



    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const crearTurno = async () => {
        setMensaje('Procesando...');

        try {


            // Crear el objeto de días y horas (campo dias)
            const diasData = [
                {
                    dia: selectedHorario.date,           // Ejemplo: Lunes, Martes, etc.
                    horaInicio: selectedHorario.horario.horaInicio,  // Ejemplo: '09:00'
                    horaFin: selectedHorario.horario.horaFin,
                }
            ]

            // Preparar FormData con los campos individuales
            const formData = new FormData();
            
            // Enviar la solicitud con los datos
            let response = '';
            if (tipoRecurso === 'taller') {
                formData.append('idTaller', idServicio);
                formData.append('taller', servicio);
                formData.append('nombre', nombre);
                formData.append('telefono', telefono.replace(/-/g, ''));
                formData.append('estado', 'Asignado');
                formData.append('dias', JSON.stringify(diasData));  // Agregar los días y horas como JSON
                formData.append('pago', 'N/A');
                response = await fetch(`${baseURL}/turnosTallerPost.php`, {
                    method: 'POST',
                    body: formData,
                });
            } else {
                formData.append('nombre', nombre);
                formData.append('telefono', telefono.replace(/-/g, ''));
                formData.append('idServicio', idServicio);
                formData.append('servicio', servicio);
                formData.append('estado', 'Pendiente');
                formData.append('dias', JSON.stringify(diasData));  // Agregar los días y horas como JSON
                response = await fetch(`${baseURL}/turnoPost.php`, {
                    method: 'POST',
                    body: formData,
                });
            }

            const data = await response.json();
            if (data.idTurno) {
                setMensaje('');

                if (tipoRecurso === 'taller') {
                    Swal.fire(
                        'Solicitud de inscripción al taller enviada',
                        `La Solicitud de cita ha quedado registrada exitosamente, una vez que se valide disponibilidad, le confirmaremos via WhatsApp`,
                        'success'
                    );
                } else {
                    Swal.fire(
                        'Solicitud de cita enviada',
                        `La Solicitud de cita ha quedado registrada exitosamente, una vez que se valide disponibilidad, le confirmaremos via WhatsApp`,
                        'success'
                    );
                }

                // Limpiar campos y cerrar modal
                setNombre('');
                setTelefono('');
                setMensaje('');
                closeModal();
                
                // Actualizar los datos según el tipo de recurso
                cargarDias();
                if (tipoRecurso === 'taller') {
                    await cargarTurnosTaller();  // Actualizar turnos del taller
                } else {
                    cargarTurnosySalas();
                }

                /*
                //aqui no se crea ni el pdf ni las notificaciones
                const detallesTurno = {
                    idTurno: data.idTurno,
                    servicio,
                    dia: dayjs(selectedHorario?.date)?.format('dddd'),
                    fecha: dayjs(selectedHorario?.date)?.format('dddd, D [de] MMMM [de] YYYY'),
                    horarioInicio: selectedHorario?.horario?.horaInicio,
                    horarioFin: selectedHorario?.horario?.horaFin,
                    nombre,
                    telefono,
                    categoria,
                    ubicacionTienda,
                };

                //crear pdf y subirlo al servidor
                enviarPdfAlServidor(detallesTurno);

                //crear notificacion
                const formData = new FormData();
                const nombreArchivo = `Cita_${detallesTurno.idTurno}_${detallesTurno.nombre
                    .replace(/\s+/g, "_")
                    .replace(/[^a-zA-Z0-9_]/g, "")}_${detallesTurno.fecha
                        .replace(/\s+/g, "_")
                        .replace(/[^a-zA-Z0-9_]/g, "")}.pdf`;
       
                formData.append('nombreArchivo', nombreArchivo);        
                formData.append('sendTo', detallesTurno.telefono.replace(/-/g, ""));
                formData.append('templateName', 'cliente_confirmacion_cita_v1');
                formData.append('bodyArray', JSON.stringify([
                    detallesTurno.fecha,
                    detallesTurno.nombre,
                    detallesTurno.categoria,
                    detallesTurno.ubicacionTienda
                ]));

                // Realizar petición al servidor
                const response = await fetch(`${baseURL}/notificationsPost.php`, {
                method: 'POST',
                    body: formData
                });
               
                */

                setTimeout(() => {
                    setSelectedHorario(null)
                }, 100);

            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                error,
                'error'
            );
        }
    };




    if (loading) {
        return <Swiper
            effect={'coverflow'}
            grabCursor={true}
            slidesPerView={'auto'}
            id="cardsServicio"
        >
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>

            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>

            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
            <SwiperSlide id="cardDayLoading">

            </SwiperSlide>
        </Swiper>;
    }

    return (
        <div className='Dias'>
            {dia ? (
                <div>
                    {selectedDay && <div className='horariosSeleccionados'>
                        <h4>{dayjs(selectedDay?.date)?.format('dddd, D [de] MMMM [de] YYYY')}:</h4>
                    </div>
                    }
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        slidesPerView={'auto'}
                        id='cardsServicio'
                    >

                        {generateMonthDays().map((monthDay, index) => {
                            const matchingDayInfo = dia?.dias?.find(d => d.dia === monthDay?.day);

                            // Verificar disponibilidad del día
                            const isDayFull = tipoRecurso === 'taller'
                                ? turnos?.filter(turno => 
                                    turno?.dias?.some(d => d.dia === monthDay.date)
                                ).length >= cupoMax
                                : matchingDayInfo?.horarios?.every(horario =>
                                    turnos?.some(turno =>
                                        turno?.dias?.some(d =>
                                            d.dia === monthDay.date &&
                                            d.horaInicio === horario.horaInicio &&
                                            d.horaFin === horario.horaFin
                                        )
                                    )
                                );

                            const disponibilidadText = matchingDayInfo
                                ? isDayFull
                                    ? <div className="red"></div> // Todos los horarios están ocupados
                                    : <div className="green"></div> // Hay horarios disponibles
                                : <div className="red"></div>; // Día no tiene horarios disponibles

                            return (
                                <SwiperSlide
                                    key={index}
                                    onClick={() => handleDayClick(monthDay, index)}
                                    id={selectedDayIndex === index ? 'selectedDay' : 'cardDay'}
                                >
                                    <h5>{dayjs(monthDay.date)?.format('dddd')}</h5>
                                    <h4>{dayjs(monthDay.date)?.format('D')}</h4>
                                    <h5>{dayjs(monthDay.date)?.format('MMMM')}</h5>
                                    {disponibilidadText}
                                </SwiperSlide>
                            );
                        })}

                    </Swiper>


                    {selectedDay ? (
                        <div className='horariosSeleccionados'>
                            <div className="flexGrapHoras">
                                {selectedDay?.horarios?.map((horario, idx) => {
                                    // Convertir horario de fin a formato numérico
                                    const [horaFin, minutoFin] = horario?.horaFin?.split(':').map(Number);
                                    const horarioFinNum = horaFin + minutoFin / 60;

                                    // Verificar si el horario está ocupado
                                    /*
                                    const isOcupado = turnos?.some(turno =>
                                        turno?.dias?.some(d =>
                                            d.dia === selectedDay.date &&
                                            d.horaInicio === horario.horaInicio &&
                                            d.horaFin === horario.horaFin
                                        )
                                    );
                                    */
                                    const citasEnEsteHorario = turnos?.filter(turno => {
                                        const tieneDia = turno?.dias?.some(d => {
                                            const fechaTurno = dayjs(d.dia).format('YYYY-MM-DD');
                                            const fechaSeleccionada = dayjs(selectedDay.date).format('YYYY-MM-DD');
                                            const coincide = fechaTurno === fechaSeleccionada && 
                                                           d.horaInicio === horario.horaInicio && 
                                                           d.horaFin === horario.horaFin;
                                            
                                            if (coincide) {
                                                /*
                                                console.log('Turno encontrado:', {
                                                    fechaTurno,
                                                    fechaSeleccionada,
                                                    horaInicio: d.horaInicio,
                                                    horaFin: d.horaFin,
                                                    turno
                                                });
                                                */
                                            }
                                            
                                            return coincide;
                                        });
                                        return tieneDia;
                                    }).length;

                                    //console.log('Citas encontradas para', selectedDay.date, horario.horaInicio, '-', horario.horaFin, ':', citasEnEsteHorario);
                                    //console.log('Turnos disponibles:', turnos);

                                    // Verificar si es taller y si se alcanzó el cupo máximo
                                    const esTallerLleno = tipoRecurso === 'taller' && 
                                        cupoMax > 0 && 
                                        citasEnEsteHorario >= cupoMax;
                                        
                                    const isOcupado = tipoRecurso === 'taller' 
                                        ? esTallerLleno 
                                        : citasEnEsteHorario >= numeroSalas;

                                    // Verificar si el horario ya pasó
                                    const isHorarioPasado = dayjs(selectedDay.date).isBefore(minDate, 'day');

                                    // Determinar el estilo del botón
                                    const buttonStyles = {
                                        cursor: isOcupado || isHorarioPasado ? 'not-allowed' : 'pointer',
                                        backgroundColor: isOcupado
                                            ? tipoRecurso === 'taller' && citasEnEsteHorario >= cupoMax 
                                                ? '#ff000026' // Rojo claro para talleres llenos
                                                : '#06b5b826' // Azul claro para programas ocupados
                                            : isHorarioPasado
                                                ? '#ff000018' // Rojo claro para horarios pasados
                                                : '',
                                        color: isOcupado
                                            ? tipoRecurso === 'taller' && citasEnEsteHorario >= cupoMax
                                                ? '#ff0000' // Rojo para talleres llenos
                                                : '#06b5b8' // Azul para programas ocupados
                                            : isHorarioPasado
                                                ? '#ff0000' // Rojo para horarios pasados
                                                : '',
                                    };

                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => !isOcupado && !isHorarioPasado && handleHorarioClick(horario, selectedDay.date)}
                                            style={buttonStyles}
                                            disabled={isOcupado || isHorarioPasado} // Desactivar si el horario está ocupado o ya pasó
                                        >
                                            {horario.horaInicio} - {horario.horaFin}
                                            {tipoRecurso === 'taller' && cupoMax > 0 && (
                                                <span style={{fontSize: '0.8em', display: 'block'}}>
                                                    {citasEnEsteHorario}/{cupoMax} lugares
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <h4 className="textCenter">Selecciona un día para ver sus horarios.</h4>
                    )}

                    {selectedHorario && (
                        <button className="btnFlotant" onClick={openModal} >{tipoRecurso === 'taller' ? 'Inscribirse al taller de':'Agendar cita de'} {selectedHorario && (
                            <>
                                {selectedHorario?.horario?.horaInicio} - {selectedHorario?.horario?.horaFin}
                            </>
                        )}</button>
                    )}
                    <Modal
                        isOpen={modalIsOpen}
                        className="modal-cart"
                        overlayClassName="overlay-cart"
                        onRequestClose={closeModal}
                    >
                        <div className='deFLex'></div>
                        <div className='deFLex'>
                            <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} /></button>
                            <button className='deleteToCart'>{tipoRecurso === 'taller' ? 'Inscribirse al taller' : 'Reservar cita'}</button>
                        </div>
                        <div className="modal-content-cart">


                            <div className="modal-send-form">
                                {selectedHorario && (
                                    <div className='deFLexRadio'>
                                        <p>{tipoRecurso === 'taller' ? 'Taller:' : 'Tipo de cita:'} {servicio}</p>
                                        {/* <p>Día: {dayjs(selectedHorario?.date)?.format('dddd')}</p> */}
                                        <p>Fecha: {dayjs(selectedHorario?.date)?.format('dddd, D [de] MMMM [de] YYYY')}</p>
                                        <p>Horario: {selectedHorario?.horario?.horaInicio} - {selectedHorario?.horario?.horaFin}</p>
                                    </div>
                                )}
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    placeholder={tipoRecurso === 'taller' ? 'Nombre y Apellido (*)' : 'Paciente: Nombre y Apellido (*)'}
                                />
                                <InputMask
                                    mask="+52-99-99-99-99-99"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                >
                                    {(inputProps) => (
                                        <input
                                            {...inputProps}
                                            type="tel"
                                            id="telefono"
                                            name="telefono"
                                            placeholder="+52-00-00-00-00-00 (*)"
                                        />
                                    )}
                                </InputMask>
                                <hr />
                                <p><strong>Condiciones generales:</strong></p>
                                <ul>
                                    <li>Si el paciente es menor de edad, el tutor que lo acompañe a la cita debe presentar una identificación oficial.</li>
                                    <li>En caso de no poder asistir, por favor cancelar con 24 horas de anticipación.</li>
                                </ul>
                                <hr />
                                {mensaje ? (
                                    <button type='button' className='btn' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <button type='button' onClick={crearTurno} className='btn'>
                                        Finalizar
                                    </button>
                                )}
                            </div>
                        </div>
                    </Modal>
                </div >
            ) : (
                <h4 className="textCenter">No se encontraron días para este servicio.</h4>
            )}
        </div >
    );
}
